<template>
<div>
    <section class="container mt-3 py-3">
          
        <h4 class="mb-3">Checkbox y switchs</h4>
    
        <div class="row">
            <div class="col-12 col-md-4">
                <vs-checkbox class="check-primary" v-model="option"> check-primary </vs-checkbox>
            </div>
            <div class="col-12 col-md-4">
                <vs-checkbox class="check-secondary" v-model="option2">check-secondary </vs-checkbox>
            </div>
            <div class="col-12 col-md-4">
                <vs-checkbox class="check-tertiary" v-model="option3"> check-tertiary </vs-checkbox>
            </div>
        </div>
        <p class="text-dark mt-4 mb-1">Clases para checkbox.</p>
        <code>
            .check-primary <br>
            .check-secondary <br>
            .check-tertiary
        </code>
        <p class="text-dark mt-4 mb-1">Codigo de ejemplo para la implementación del checkbox.</p>
        <!-- CODIGO HTML -->
        <div class="p-3 bg-white" v-highlight><pre class="language-html p-0"><code><script type="text/plain" class="language-markup"><vs-checkbox class="check-primary" v-model="option"> check-primary </vs-checkbox>
</script></code></pre>
        </div>
        <!-- CODIGO HTML -->
        <div class="row mt-5">
            <div class="col-12 col-md-4">
                <vs-switch class="switch-primary" v-model="active" />
                switch-primary
            </div>
            <div class="col-12 col-md-4">
                <vs-switch class="switch-secondary" v-model="active2" />
                switch-secondary
            </div>
            <div class="col-12 col-md-4">
                <vs-switch class="switch-tertiary" v-model="active3" />
                switch-tertiary
            </div>
        </div>
        <p class="text-dark mt-4 mb-1">Clases para switch.</p>
        <code>
            .switch-primary <br>
            .switch-secondary <br>
            .switch-tertiary
        </code>
        <p class="text-dark mt-4 mb-1">Codigo de ejemplo para la implementación del switch.</p>
        <div class="p-3 bg-white" v-highlight><pre class="language-html p-0"><code><script type="text/plain" class="language-markup"><vs-switch class="switch-primary" v-model="active" />
</script></code></pre>
        </div>
    
    
    </section>

    <section class="container mt-3 py-3">
        <h4>Radios</h4>
    <div class="row radio-secondary">
        <div class="col-4 col-md-3">
             <vs-radio v-model="picked" val="1">valor 1 </vs-radio>
         </div>
        <div class="col-4 col-md-3">
            <vs-radio v-model="picked" val="2">valor 2 </vs-radio>
        </div>
        <div class="col-4 col-md-3">
            <vs-radio v-model="picked" val="3">valor 3 </vs-radio>
        </div>
        <div class="col-12 col-md-3">
            descripcion: valor <strong>{{picked}}</strong>
        </div>
    </div>
    <p class="text-dark mt-4 mb-1">Clases para radios.</p>
    <code>
        .radio-primary <br>
        .radio-secondary <br>
        .radio-tertiary
    </code>

    <p class="text-dark mt-4 mb-1">
     Para la implementación de los radio colors, se debe colocar la clase en un contenedor que envuelva los radio   
    </p>
    <div class="p-3 bg-white" v-highlight><pre class="language-html p-0"><code><script type="text/plain" class="language-markup"><div class="radio-primary">
    <vs-radio v-model="picked" val="1"> Valor 1</vs-radio>
    <vs-radio v-model="picked" val="2"> Valor 2</vs-radio>
    <vs-radio v-model="picked" val="3"> Valor 3</vs-radio>
</div>
</script></code></pre>
    </div>
    
    </section>
 
 </div>    
</template>
<script>

export default({
    created(){
        window.scrollTo(0, 0);
    },
    data: function() {
        return{
            option: true,
            option2: true,
            option3: true,
            active: true,
            active2: true,
            active3: true,
            picked:1,

            htmlvalue: '<vs-checkbox class="',
            htmlvalue2: '" v-model="option"> check-primary </vs-checkbox>',

            htmlvalue3: '<vs-switch class="',
            htmlvalue4: '" v-model="active" />',

            htmlvalue5: '<div class="',
            htmlvalue6: '</div>',
            htmlvalue7: '<vs-radio v-model="picked" val="',
            htmlvalue8:'</vs-radio>'
        }
    },
})

</script>

<style scoped>
.radio-secondary>div{
    display: flex;
    justify-content: flex-start;
}
</style>
